import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/navigation-service`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/navigation-service/${id}`);
  },
  async findAll() {
    return axios.get('/navigation-service');
  },
  async delete({ id }) {
    return axios.delete(`/navigation-service/${id}`);
  },
  async update(formData) {
    return axios.put(`/navigation-service/${formData.id}`, formData);
  }
};
